import { render, staticRenderFns } from "./SideBarReleasesNotes.vue?vue&type=template&id=0995e3a8&scoped=true&"
import script from "./SideBarReleasesNotes.vue?vue&type=script&lang=js&"
export * from "./SideBarReleasesNotes.vue?vue&type=script&lang=js&"
import style0 from "./SideBarReleasesNotes.vue?vue&type=style&index=0&id=0995e3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995e3a8",
  null
  
)

export default component.exports